import script from "./ProductsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsList.vue?vue&type=script&setup=true&lang=ts"

import "./ProductsList.vue?vue&type=style&index=0&id=3dc59d7a&lang=scss"

const __exports__ = script;

export default __exports__